module.exports = __webpack_public_path__ + "img/bifood.e98ffc58.png";